<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation>
			<v-row>
				<v-col cols="12">
					<v-text-field ref="title" v-model="localData.title" label="عنوان*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان هزینه را وارد کنید']" required />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<div>تاریخ*</div>
						<date-picker ref="costDate" v-model="localData.costDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable auto-submit />
						<div class="red--text">
							{{ datePickerValidatioin }}
						</div>
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<v-text-money ref="amount" v-model="localData.amount" label="مبلغ*" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-text-field v-model="localData.comment" :error-messages="errorMessages" :type="'textarea'" label="توضیحات" hint="حداکثر 1000 کاراکتر" />
				</v-col>
			</v-row>
			<small>*فیلدهای ستاره دار ضروری هستند.</small>
		</v-form>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck',false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyExpenseView',
		components: {
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				datePickerValidatioin: '',
			}
		},
		mounted() {
			this.prepareData()
		},
		methods: {
			submit() {
				this.datePickerValidatioin = ''
				if (this.localData.regDate2 === '') {
					this.datePickerValidatioin = 'تاریخ را وارد کنید'
					return
				}
				if (!this.$refs.form.validate()) { return }

				api.post('admin/expense/' + (this.localData.id === emptyId ? 'create' : 'edit'), this.localData)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				api.get('admin/expense/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === emptyId) Object.assign(this.localData, this.data)
							if (this.localData.costDate === '0001-01-01T00:00:00') { this.localData.costDate = '' }
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
		},
	}
</script>
<style>
</style>
